<template>
    <div
        ref="mlNode"
        class="ml-entity-selector--node"
    >
        <div
            ref="nodeBody"
            class="node-body"
            @click="selectEntity(mlEntity)"
        >
            <div class="node-name">
                {{mlEntity.name}}
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'ml-entity-selector',

  props: {
    mlEntity: {
      type: Object,
      required: true
    },
    headNode: Boolean
  },

  methods: {
    selectEntity (entity) {
      if (entity.name === this.mlEntity.name) {
        // We remove children so that we can find selected entity(e.g. has no child = selected)
        this.$emit('select', { ...entity, children: [] })
      } else {
        this.$emit('select', {
          ...this.mlEntity,
          children: [entity]
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
    .ml-entity-selector--node {
        &:hover {
            background-color: rgb(246, 246, 246);
        }
        .node-body {
            display: flex;
            align-items: center;
            padding: 8px;
            cursor: pointer;
        }
        .node-name {
            color: rgb(30, 35, 43);
            font-size: 14px;
            font-weight: 600;
        }
    }
</style>
